<template>
  <div class="page-footer">
    <div class="page-footer__title">
      <span class="contact-link">CONTACT</span>
    </div>
    <div class="page-footer__main" @click="onOpenLink(`mailto:${contactPoint}`)">
      Questions? Contact the Construct Team.
    </div>
    <div class="page-footer__links">
      <ul class="page-footer__links__link-group">
        <div class="plus-container">
          <div class="plus-container__top--left"></div>
          <div class="plus-container__bottom--right"></div>
        </div>

        <li class="page-footer__links__link-group__link">
          <img
            class="links-icon"
            src="@/assets/images/twitter_white.png"
            @click="onOpenLink('https://twitter.com/constructcap')"
          />
          <img
            class="links-icon"
            src="@/assets/images/linkedin_white.png"
            @click="onOpenLink('https://linkedin.com/company/constructcap/')"
          />
        </li>
     
        <li
          class="page-footer__links__link-group__link page-footer__links__link-group__link--main"
        >
        &#169 2025
        </li>
        <li
          class="page-footer__links__link-group__link page-footer__links__link-group__link-tc"
          @click="onOpenLink('https://constructcap.com/terms ')"
        >
          TERMS OF USE
        </li>
        <li
          class="page-footer__links__link-group__link page-footer__links__link-group__link--final"
        ></li>
        <div class="plus-container">
          <div class="plus-container__top--left"></div>
          <div class="plus-container__bottom--right"></div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  methods: {
    onOpenLink(link) {
      window.open(link, '_blank')
    },
  },
  computed: {
    contactPoint() {
      return process.env.VUE_APP_CONTACT_POINT
        ? process.env.VUE_APP_CONTACT_POINT
        : 'LPportal@constructcap.com'
    },
    copywrite() {
      return '&#169 2021'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/fontstyles';
* {
  color: $stain;
}
.plus-container {
  width: 23px;
  height: 23px;

  display: block;
  &__top--left {
    background: white;
    top: 48%;
    content: '';
    height: 1px;
    position: relative;
    width: 23px;
  }
  &__bottom--right {
    background: white;
    left: 48%;
    content: '';
    height: 23px;
    position: relative;
    width: 1px;
  }
}
.page-footer {
  @media screen and (max-width: 768px) {
    padding: 0rem 0rem;
  }
  position: absolute;
  bottom: 0;
  height: 15rem;
  width: 100%;
  background-color: #2c2b2b;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  padding: 1rem 2rem;
  &__title,
  &__main,
  &__links {
    width: 100%;
    padding: 0rem 5rem;
  }
  &__main {
    &:hover {
      cursor: pointer;
    }
    @include page-title-font();
    text-align: left;
    align-self: center;
    color: $stain;
    line-height: 80px;
    @media screen and (max-width: 768px) {
      @include base-font(
        $fontsize: 30px,
        $lineheight: 35px,
        $fontfam: $alt-font-family,
        $fontcolor: $stain
      );
      font-weight: normal;
    }
  }

  &__links {
    &__link-group {
      display: flex;
      justify-content: center;
      align-items: center;

      &__link {
        margin: 0rem 1rem;
        &-tc {
          &:hover {
            cursor: pointer;
          }
          @media screen and (max-width: 768px) {
            flex: 1 0 auto;
          }
        }

        &--main {
          flex: 1 0 auto;
          @media screen and (max-width: 768px) {
            flex: 0 0 auto;
            top: -7px;
          }
        }
      }
    }
  }
}
.contact-link,
.page-footer__links__link-group__link {
  list-style: none;
  @include navbar-item-font($fontcolor: $stain);
}
.links-icon {
  height: 1.5rem;
  &:hover {
    cursor: pointer;
  }
}
.alt-links-icon {
  height: 3.5rem;
  fill: $stain;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
ul {
  padding: 0;
}
</style>
